export default () => typeof window !== 'undefined'
// && typeof window.innity_adZoneAsync !== 'undefined'
// && typeof window.innity_adZoneAsync.display === 'function'
